<template>
  <div
    class="e-skeleton-loader"
    :class="{
      inline,
      'paragraph-m_h': type === 'paragraph-m_h',
      round: type === 'round',
      h3: type === 'h3',
      caption: type === 'caption',
    }"
  >
    <v-skeleton-loader type="text" :width="width" />
  </div>
</template>

<script setup lang="ts">
import { VSkeletonLoader } from 'vuetify/components';

withDefaults(
  defineProps<{
    type?: 'type' | 'paragraph-m_h' | 'round' | 'h3' | 'caption';
    width?: string;
    height?: string;
    inline?: boolean;
  }>(),
  { height: '1.5em' },
);
</script>

<style scoped lang="scss">
.e-skeleton-loader {
  --skeleton-height: v-bind(height);

  &.inline {
    display: inline-block;

    vertical-align: sub;
  }

  :deep(.v-skeleton-loader__bone) {
    height: var(--skeleton-height);
    margin: 0;

    background: $bg-light-color;
    border-radius: $border-radius-l;

    &::after {
      background: linear-gradient(
        90deg,
        rgba(var(--v-theme-surface), 0),
        rgba(var(--v-theme-surface), 0.6),
        rgba(var(--v-theme-surface), 0)
      );
    }
  }

  &.h3 {
    --skeleton-height: 28px;

    @include md-and-down {
      --skeleton-height: 24px;
    }
  }

  &.paragraph-m_h {
    --skeleton-height: 24px;

    @include md-and-down {
      --skeleton-height: 20px;
    }
  }

  &.caption {
    --skeleton-height: 24px;

    @include md-and-down {
      --skeleton-height: 16px;
    }
  }

  &.round {
    :deep(.v-skeleton-loader__bone) {
      border-radius: 50%;
    }
  }
}
</style>
